import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import { useSelector, useDispatch } from 'react-redux'

import { useBooleanState } from 'hooks/useBooleanState'

import { toggleEnforcement } from './actions'
import { samlSettingsSelector } from './selectors'


// i18n-tasks-use t('publisher.organization_settings.sso.enforcement.popup.enable_title')
// i18n-tasks-use t('publisher.organization_settings.sso.enforcement.popup.enable_description')
// i18n-tasks-use t('publisher.organization_settings.sso.enforcement.popup.disable_title')
// i18n-tasks-use t('publisher.organization_settings.sso.enforcement.popup.disable_description')
export const EnforcementPopup = ({ onClose }) => {
  const dispatch = useDispatch()
  const { state } = useSelector(samlSettingsSelector)
  const [isLoading, startLoading, stopLoading] = useBooleanState(false)
  const action = state === 'enforced' ? 'disable' : 'enable'

  const onConfirm = async () => {
    startLoading()
    try {
      await dispatch(toggleEnforcement())
    } finally {
      stopLoading()
    }
  }

  return (
    <Popup
      onClose={onClose}
      title={I18n.t(`publisher.organization_settings.sso.enforcement.popup.${action}_title`)}
    >
      <Body>
        {I18n.t(`publisher.organization_settings.sso.enforcement.popup.${action}_description`)}
      </Body>
      <Footer>
        <Button
          decoration="secondary-outline"
          onClick={onClose}
          disabled={isLoading}
        >
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button
          disabled={isLoading}
          loading={isLoading}
          onClick={onConfirm}
        >
          {I18n.t('publisher.action.yes')}
        </Button>
      </Footer>
    </Popup>
  )
}
